<script>
export default {
  name: 'TableColumn',
  props: ['prop', 'title', 'width', 'classes'],
};
</script>
